import { forwardRef } from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import { Outlet } from "react-router";
import NavComponent from "./nav";
import ScrollToTop from "../common/scroll-to-top";

const formatOfficePhone = (phone) => {
  const digits = ("" + phone).replace(/\D/g, "");
  if (digits.length !== 10) return phone;
  return "(" + digits.substring(0, 3) + ") " + digits.substring(3, 6) + "-" + digits.substring(6);
}

const PrivateLayout = forwardRef((props, ref) => {
  const agencyPhone = props.userData && props.userData.agencyInfo ? props.userData.agencyInfo.phone : null;
  return (
    <div className="private-layout">
      <Container fluid>
        {props.userData && props.userData.applicantStatus === "error" && (
          <Row>
            <Col>
              <Alert variant="danger" className="text-center fw-bold mt-3">
                There is a problem with your application. Please call the office
                {agencyPhone ? " at " + formatOfficePhone(agencyPhone) : ""} for assistance.
              </Alert>
            </Col>
          </Row>
        )}
        <Row>
          <Col lg={3}>
            <NavComponent
              userData={props.userData}
              enablePhases={props.enablePhases}
            />
          </Col>
          <Col lg={9}>
            <main className="shake-me" ref={ref}>
              <ScrollToTop />
              <Outlet />
            </main>
          </Col>
        </Row>
      </Container>
    </div>
  );
});

export default PrivateLayout;
